<div class="{{'single-select-' + id + ' single-select'}}" [ngStyle]="{'width': width}">
  <!-- <div (mouseover)="openDropDownList = true" (mouseout)="openDropDownList = false" class="list-view"> -->
    <div (click)="toggleDropDown()" class="list-view" [ngStyle]="{'cursor': !disabled ? 'pointer' : 'not-allowed' }">
      <span>
          {{(selectedValue == null || selectedValue == '') ? placeHolder : selectedValue}}
      </span>
      <img src="/assets/arrow-down.png" alt="down" style="height: 10px;">
    </div>
    <div *ngIf="openDropDownList " (mouseover)="openDropDownList = true" class="dropDownValues">
        <input *ngIf="showSearchBox" type="text" class="browser-default" [(ngModel)]="searchedString">
        <div>
            <div class="" *ngFor="let value of values; let j = index;" (click)="select(j)">
                <div class="marginLeft10 dropDownValue">
                    <div>
                        <span title="{{value ? value[displayName] : 'NA'}}"> {{value ? value[displayName] : 'NA'}} </span>
                        <!-- <span > {{value}} </span> -->
                    </div>
                </div>
            </div>
            <span class="noData" *ngIf="values.length == 0"> No data available </span>
        </div>
    </div>
  </div>